<div
  class="text-center relative color-light border-radius-5 overflow-hidden m-a pointer"
  style="max-width: fit-content"
  [routerLink]="['/', paths.PLATFORM, paths.platform.PROPERTIES]">
  <!-- Header -->
  <cp-widget-header
    text="Mortgage status"
    icon="mortgage"
    [isAbsolutePosition]="true"
    variant="green" />

  <!-- Video -->
  <div class="absolute z-index-3 bottom-3" visibility (visibilityChange)="playVideo($event)"></div>
  <div class="relative">
    <video
      class="border-radius-5"
      #bestDealVid
      (ended)="videoEnded = true"
      style="width: 100%"
      playsinline
      [poster]="'dashboard-widget-poster-present.jpg' | brandingAssetPath"
      [muted]="muted">
      @if (!isCompanyBranded) {
        <source src="/assets/videos/present.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      }
    </video>
  </div>

  <!-- Contents -->
  <ng-container *ngTemplateOutlet="videoContent" />
</div>

<ng-template #videoContent>
  <div class="w-100 h-100 z-index-1 absolute video-content pt-5 pb-3">
    <div class="text-28 bold-800 px-3 text-center pt-3">Relax, you‘re still on the best deal!</div>
    <div class="text-14 px-5 bottom-3 text-center">
      As of today you're on the right deal. But don't worry, we'll continue to monitor your mortgage
      every day to ensure that you always remain on the right deal for you.
    </div>
  </div>
</ng-template>
